import service from '@/api/newsletter/template';
import {loading, handleError} from '@/state/generators/helpers';
import {alert} from "../../generators/helpers";

export const state = {
    service: service('newsletters/templates'),
    templates: [],
    loadingTemplates: false,
}

export const getters = {
    loadingTemplates: state => {
        return !!state.loadingTemplates;
    },

    templates: state => {
        return state.templates?.length ? JSON.parse(JSON.stringify(state.templates)) : [];
    }
}

export const mutations = {
    'SET_LOADING_TEMPLATES': function (state, boolean = true) {
        state.loadingTemplates = boolean;
    },

    'SET_TEMPLATES': function (state, arr = []) {
        state.templates = arr;
    }
}

export const actions = {
    copy: function ({commit, state}, id) {
        loading(commit)

        return state.service.copy(id).then(response => {
            const model = Object.assign({}, response.data)

            commit('ADD_ITEM', model);
            commit('SET_ITEM', model);
            alert(commit, this.$t('request.save_is_successful'))
            commit('SET_ERRORS', {});
            loading(commit, false)

            return model;
        }).catch((e) => {
            handleError(e, commit)
        })
    },

    templates: function ({commit, state}) {
        loading(commit);
        commit('SET_LOADING_TEMPLATES');

        return state.service.templates().then(response => {
            commit('SET_TEMPLATES', response.data);
            loading(commit, false);
            commit('SET_LOADING_TEMPLATES', false);

            return response.data;
        }).catch((e) => {
            handleError(e, commit)
        })
    },
}
